import { IDichVuSelectRequest } from "../../../models/request/dich-vu/dichVuRequests";
import { ISaleSetRegisterInsertMultipleRequest } from "../../../models/request/dich-vu/saleSetRegisterRequests";
import { SaleSetRegisterHTNopPhiItemResponse } from "../../../models/response/dich-vu/sf_saleset_register_htnopphi";
import { sf_saleset_register_type, SaleSetRegisterTypeItemResponse } from "../../../models/response/dich-vu/sf_saleset_register_type";
import {
	eSaleSetRegisterActionTypeIds,
	ISaleSetRegisterChangeSelectedIds,
	ISaleSetRegisterCloseDetail,
	ISaleSetRegisterLoadErr,
	ISaleSetRegisterLoadStart,
	ISaleSetRegisterLoadSuccess,
	ISaleSetRegisterSaveErr,
	ISaleSetRegisterSaveStart,
	ISaleSetRegisterSaveSuccess,
	ISaleSetRegisterShowDetail,
	ISaleSetRegisterTypeByHocSinhLoadErr,
	ISaleSetRegisterTypeByHocSinhLoadStart,
	ISaleSetRegisterTypeByHocSinhLoadSuccess,
	ISaleSetRegisterTypeLoadErr,
	ISaleSetRegisterTypeLoadStart,
	ISaleSetRegisterTypeLoadSuccess
} from "../../action-types/dich-vu/ISaleSetRegisterActionTypes";

export const saleSetRegisterActions = {
	loadSaleSetRegisterStart: (request: IDichVuSelectRequest): ISaleSetRegisterLoadStart => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadSaleSetRegisterSuccess: (data: SaleSetRegisterHTNopPhiItemResponse[]): ISaleSetRegisterLoadSuccess => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadSaleSetRegisterError: (message: string): ISaleSetRegisterLoadErr => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadSaleSetRegisterTypeStart: (): ISaleSetRegisterTypeLoadStart => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_START
		}
	},
	loadSaleSetRegisterTypeSuccess: (data: sf_saleset_register_type[]): ISaleSetRegisterTypeLoadSuccess => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_SUCCESS,
			payload: data
		}
	},
	loadSaleSetRegisterTypeError: (message: string): ISaleSetRegisterTypeLoadErr => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_ERROR,
			payload: message
		}
	},
	loadSaleSetRegisterTypeByHocSinhStart: (ts_hocsinh_id: number): ISaleSetRegisterTypeByHocSinhLoadStart => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_START,
			payload: ts_hocsinh_id
		}
	},
	loadSaleSetRegisterTypeByHocSinhSuccess: (data: SaleSetRegisterTypeItemResponse[]): ISaleSetRegisterTypeByHocSinhLoadSuccess => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_SUCCESS,
			payload: data
		}
	},
	loadSaleSetRegisterTypeByHocSinhError: (message: string): ISaleSetRegisterTypeByHocSinhLoadErr => {
		return {
			type: eSaleSetRegisterActionTypeIds.LOAD_REGISTER_TYPE_BY_HOCSINH_ERROR,
			payload: message
		}
	},
	showSaleSetRegisterDetail: (data: SaleSetRegisterHTNopPhiItemResponse): ISaleSetRegisterShowDetail => {
		return {
			type: eSaleSetRegisterActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeSaleSetRegisterDetail: (): ISaleSetRegisterCloseDetail => {
		return {
			type: eSaleSetRegisterActionTypeIds.CLOSE_DETAIL
		}
	},
	changeSaleSetRegisterSelectedIds: (ids: number[]): ISaleSetRegisterChangeSelectedIds => {
		return {
			type: eSaleSetRegisterActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	saveSaleSetRegisterStart: (request: ISaleSetRegisterInsertMultipleRequest): ISaleSetRegisterSaveStart => {
		return {
			type: eSaleSetRegisterActionTypeIds.SAVE_START,
			payload: request
		}
	},
	saveSaleSetRegisterSuccess: (): ISaleSetRegisterSaveSuccess => {
		return {
			type: eSaleSetRegisterActionTypeIds.SAVE_SUCCESS
		}
	},
	saveSaleSetRegisterError: (message: string): ISaleSetRegisterSaveErr => {
		return {
			type: eSaleSetRegisterActionTypeIds.SAVE_ERROR,
			payload: message
		}
	}
}
